import { useState, useRef, useEffect, useContext } from "react";

import { Link } from "react-router-dom";

import "./Header.scss";
import { TextInput, Button, Utils } from "../Components";
import { UserContext } from "../Contexts";

import { Dropdown } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";

export const Header = ({ setLoading }) => {
  const { isLogedIn, account, setAccount, setAccounts } = useContext(UserContext);

  const dropdownUserMenu = useRef();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nameAccount, setNameAccount] = useState([]);
  const [formKey, setFormKey] = useState(0);

  const [accountList, setAccountList] = useState([]);
  // Seleção por índice do accountList (único por linha), não por erpConta
  // (erpConta pode repetir entre contas diferentes e causava marcar 2 itens de uma vez).
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isAccOpen, setIsAccOpen] = useState(false);
  const [pendingKeys, setPendingKeys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [bulkPage, setBulkPage] = useState(0);
  const defaultSelectionInitializedRef = useRef(false);


  const MAX_SELECTED = 50;


  useEffect(() => {
    ListTheAccounts();
  }, []);

  const validatePassword = (password, confirmPassword, oldPassword) => {
    const lengthCheck = password.length >= 7 && password.length <= 29;
    const numberCheck = /\d/.test(password);
    const lowerCaseCheck = /[a-z]/.test(password);
    const upperCaseCheck = /[A-Z]/.test(password);
    const specialCharCheck = /[$*&@#]/.test(password);
    const someInputNotFill = !password || !confirmPassword || !oldPassword;
    const passwordsNotMatch = password !== confirmPassword;

    if (someInputNotFill) return "Please fill out both fields.";
    if (passwordsNotMatch) return "The passwords do not match. Please try again.";
    if (!lengthCheck) return "Password must be between 7 and 29 characters.";
    if (!numberCheck) return "Password must contain at least one number.";
    if (!lowerCaseCheck) return "Password must contain at least one lowercase letter.";
    if (!upperCaseCheck) return "Password must contain at least one uppercase letter.";
    if (!specialCharCheck) return "Password must contain at least one special character ($*&@#).";

    return "";
  };

  const handleLogout = () => {
    Utils.Confirm({
      title: "Logout",
      text: "You really wish to logout?",
      onYes: () => {
        localStorage.removeItem("logedInUser");
        localStorage.removeItem("account");
        localStorage.removeItem("nameClient");
        window.location.href = "/portal";
      },
    });
  };

  const handleChangePassword = () => {
    dropdownUserMenu.current.classList.toggle("reset");
  };

  const handleResetConfirm = async () => {
    const userData = localStorage.getItem("logedInUser");

    const passwordsErrors = validatePassword(newPassword, confirmPassword, oldPassword);
    if (passwordsErrors) {
      return Utils.Alert({ title: "Error", text: passwordsErrors });
    }

    setLoading(true);
    const result = await Utils.UpdateHash({
      new_password: newPassword,
      old_password: oldPassword,
    });

    if (result.status === 200) {
      Utils.Alert({
        title: "Success",
        text: "Password successfuly updated, please sign in again.",
        callback: () => {
          localStorage.removeItem("logedInUser");
          window.location.href = "/portal";
        },
      });
    } else {
      Utils.Alert({
        title: `Error: ${result.status}`,
        text: "Password couldn't be updated, please try again later",
      });
    }
    return setLoading(false);
  };

  const handleResetCancel = () => {
    dropdownUserMenu.current.classList.toggle("reset");
    setFormKey((prevKey) => prevKey + 1); // Atualiza a chave para recriar o formulário
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  // Mantém o índice original de cada item no accountList para usar como chave única de seleção.
  const filteredAccountList = accountList
    .map((item, index) => ({ item, index }))
    .filter(({ item }) =>
      item.nameConta?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const ListTheAccounts = async () => {
    let shippingAccounts = await Utils.getAccountList();

    shippingAccounts = shippingAccounts.filter((item) => {
      return item.Mensagem != "Not Authorized";
    });

    setAccountList([...shippingAccounts]);
  };

  useEffect(() => {
    if (!accountList.length) return;
    if (defaultSelectionInitializedRef.current) return;

    const first = accountList[0];
    if (!first) return;

    setSelectedKeys([0]);
    setAccounts([first]);
    localStorage.setItem("accounts", JSON.stringify([first]));
    localStorage.setItem("nameClients", JSON.stringify([first.nameConta]));
    defaultSelectionInitializedRef.current = true;
  }, [accountList, setAccounts]);

  const confirmedCount = selectedKeys.length;
  const pendingCount = pendingKeys.length;
  
  const currentCount = isAccOpen ? pendingCount : confirmedCount;
  
  const summaryText = currentCount
    ? `${currentCount}/${MAX_SELECTED} selected`
    : "Select accounts";

    const totalPages = filteredAccountList.length
  ? Math.ceil(filteredAccountList.length / MAX_SELECTED)
  : 0;

const currentPage = bulkPage >= totalPages ? 0 : bulkPage;

const pageStartIndex = currentPage * MAX_SELECTED;
const pageEndIndex = pageStartIndex + MAX_SELECTED;

const currentPageAccounts = filteredAccountList.slice(pageStartIndex, pageEndIndex);


    const allSelectedPending =
    currentPageAccounts.length > 0 &&
    currentPageAccounts.every(({ index }) => pendingKeys.includes(index));

    const toggleAllPending = () => {
      if (!currentPageAccounts.length) return;
    
      if (allSelectedPending) {
        setPendingKeys((prev) =>
          prev.filter((key) => !currentPageAccounts.some(({ index }) => index === key))
        );
      } else {
        const pageKeys = currentPageAccounts.map(({ index }) => index);
        setPendingKeys(pageKeys);
      }
    };

    const goToPage = (pageIndex) => {
      if (!totalPages) return;
    
      const normalized = (pageIndex + totalPages) % totalPages;
      setBulkPage(normalized);
    
      const start = normalized * MAX_SELECTED;
      const slice = filteredAccountList.slice(start, start + MAX_SELECTED);
      setPendingKeys(slice.map(({ index }) => index));
    };
    
    const handleNextBulkPage = () => {
      if (!totalPages) return;
      goToPage(currentPage + 1);
    };
    
    const handlePrevBulkPage = () => {
      if (!totalPages) return;
      goToPage(currentPage - 1);
    };
    

const toggleOnePending = (key) => {
  setPendingKeys((prev) => {
    const exists = prev.includes(key);
    if (!exists && prev.length >= MAX_SELECTED) {
      Utils.Alert({
        title: "Limit reached",
        text: `You can select a maximum of ${MAX_SELECTED} accounts.`,
      });
      return prev;
    }
    return exists ? prev.filter((v) => v !== key) : [...prev, key];
  });
};

  const handleConfirmSelection = () => {
    const selected = accountList.filter((_, index) => pendingKeys.includes(index));
    setSelectedKeys(pendingKeys);
    setAccounts(selected);
    localStorage.setItem("accounts", JSON.stringify(selected));
    localStorage.setItem("nameClients", JSON.stringify(selected.map((a) => a.nameConta)));
    setIsAccOpen(false);
  };


  const handleClearPending = () => {
    setPendingKeys([]);
  };  

  return (
    <nav>
      <div className='logo'>
        <img src='/images/logos/header_logo.png' alt='' />
      </div>

      <div>
      <div className='accountSelect'>
        <Dropdown
          text={summaryText}
          className='accountDropdown'
          multiple
          selection
          open={isAccOpen}
          onOpen={() => {
            setIsAccOpen(true);
            setPendingKeys(selectedKeys);
          }}
          onClose={() => setIsAccOpen(false)}
          closeOnChange={false}
          closeOnBlur={false}
          closeOnEscape={false}
          selectOnNavigation={false}
        >
          <Dropdown.Menu className="accountDropdown__menu">
            <div className="accountDropdown__top">
              <Dropdown.Item
              style={{ fontSize: 16, fontWeight: 600 }}
              key="__all__"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleAllPending(); }}
              text={
                allSelectedPending
                  ? `Uncheck`
                  : `Select up to ${MAX_SELECTED} (${currentPage + 1}/${totalPages || 1})`
              }
              icon={allSelectedPending ? "check square" : "square outline"}
            />

              {totalPages > 1 && (
                <div
                  className="accountDropdown__pageNav"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button type="button" onClick={handlePrevBulkPage}>
                    ◀ Prev {MAX_SELECTED}
                  </button>
                  <span>
                    {currentPage + 1} / {totalPages}
                  </span>
                  <button type="button" onClick={handleNextBulkPage}>
                    Next {MAX_SELECTED} ▶
                  </button>
                </div>
              )}
              <div className="accountDropdown__search">
                <input
                  type="text"
                  placeholder="Search accounts..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.stopPropagation();
                    }
                  }}
                />
              </div>

                <div className="accountDropdown__actions">
                  <Button
                    type='red'
                    caption='Clear'
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick= {handleClearPending}
                  />
                  <Button
                    type='blue'
                    caption='Confirm'
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={handleConfirmSelection}
                  />
                </div>
            </div>

            <div className="accountDropdown__list">
              {filteredAccountList.map(({ item, index }) => {
                const isChecked = pendingKeys.includes(index);
                const reachedLimit = pendingKeys.length >= MAX_SELECTED;
                return (
                  <Dropdown.Item
                    style={{ fontSize: 15 }}
                    key={index}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleOnePending(index); }}
                    text={item.nameConta}
                    icon={isChecked ? "check square" : "square outline"}
                    disabled={!isChecked && reachedLimit}
                    title={item.nameConta}
                  />
                );
              })}
            </div>
          </Dropdown.Menu>
        </Dropdown>

          <span className="accountSelect__hint">
           Click the field above to choose the accounts you want to view.
          </span>
      </div>
      </div>

      <div className='rightMenu'>
        <ul className='menu'>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/shipping/schedule-documents'>Shipping</Link>
          </li>
          <li className='userMenu'>
            {isLogedIn.name}
            <div className='dropdownUserMenu' ref={dropdownUserMenu}>
              <ul className='hidden'>
                <li className='logout' onClick={handleChangePassword}>
                  Change Password
                </li>
                <li className='logout' onClick={handleLogout}>
                  Logout
                </li>
              </ul>
              <div key={formKey} className='resetPassword'>
                <h2>Reset Password:</h2>
                <form className='passwordResetForm'>
                  <TextInput
                    value={oldPassword}
                    type='password'
                    caption='Old Password'
                    onChange={setOldPassword}
                  />
                  <TextInput
                    value={newPassword}
                    type='password'
                    caption='New Password'
                    onChange={setNewPassword}
                  />
                  <TextInput
                    value={confirmPassword}
                    type='password'
                    caption='Confirm Password'
                    onChange={setConfirmPassword}
                  />
                  <Button type='blue' caption='Confirm' onClick={handleResetConfirm} />
                  <Button type='red' caption='Cancel' onClick={handleResetCancel} />
                </form>
              </div>
            </div>
          </li>
        </ul>
      </div>     
    </nav>
  );
};

export default Header;
